import React, { FC } from 'react';
import LocationIcon from '../../../../../assets/icons/inline/location-blue.inline.svg';
import RoutingIcon from '../../../../../assets/icons/inline/routing-blue.inline.svg';
import MonitorIcon from '../../../../../assets/icons/inline/monitor-blue.inline.svg';
import OtherIcon from '../../../../../assets/icons/inline/globe-blue.inline.svg';
import * as classes from './AppointmentTypesList.module.scss';
import { AppointmentTypesEnum } from '../../../../../enums/AppointmentTypesEnum';
import DottedList from '../../../../Common/DottedList/DottedList';
import cn from 'classnames';
import { IAppointmentTypes } from '../../../../../interfaces/professional/Professional';

interface Props {
  items: Array<IAppointmentTypes>;
}

const AppointmentTypesList: FC<Props> = ({ items }) => {
  const defaultItemsMapper = (item: IAppointmentTypes) => {
    if (item.title === AppointmentTypesEnum.ONLINE) {
      return (
        <div key={item.id} className={cn(classes.item, 'col-12 col-sm-6')}>
          <MonitorIcon />
          {item.title}
        </div>
      );
    }
    if (item.title === AppointmentTypesEnum.AT_MY_LOCATION) {
      return (
        <div key={item.id} className={cn(classes.item, 'col-12 col-sm-6')}>
          <LocationIcon />
          {item.title}
        </div>
      );
    }
    if (item.title === AppointmentTypesEnum.AT_YOUR_LOCATION) {
      return (
        <div key={item.id} className={cn(classes.item, 'col-12 col-sm-6')}>
          <RoutingIcon />
          {item.title}
        </div>
      );
    }
    return null;
  };

  const defaultItems = items
    .filter(
      item =>
        item.title !== AppointmentTypesEnum.ONLINE &&
        item.title !== AppointmentTypesEnum.AT_YOUR_LOCATION &&
        item.title !== AppointmentTypesEnum.AT_MY_LOCATION,
    )
    .map(item => item.title);

  return (
    <div className={cn(classes.wrapper, 'row')}>
      {items.map(defaultItemsMapper)}
      {!!defaultItems.length && (
        <div className={cn(classes.otherItem, 'col-12')}>
          <div>
            <OtherIcon />
          </div>
          <DottedList items={defaultItems} />
        </div>
      )}
    </div>
  );
};

export default AppointmentTypesList;
